// Import model
import { DataviewProjectResponse } from '../models/DataviewProjectResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterProjectRequest } from '../models/FilterProjectRequest';
import { Project } from '../models/Project';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterProjectRequestSerializer } from './FilterProjectRequestSerializer';
import { ProjectSerializer } from './ProjectSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewProjectResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewProjectResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewProjectResponse instance
   */
  static deserialize(json: string): DataviewProjectResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewProjectResponse instance
   */
  static fromObject(obj: any): DataviewProjectResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewProjectResponse');
    }


    const instance: DataviewProjectResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ProjectSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterProjectRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewProjectResponse instances
   */
  static deserializeArray(json: string): DataviewProjectResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewProjectResponse instance to a JSON string
   */
  static serialize(instance: DataviewProjectResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewProjectResponse instance to a plain object
   */
  static toObject(instance: DataviewProjectResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ProjectSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterProjectRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewProjectResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewProjectResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
